/**
 * QueryClient — TanStack Query 5. Cùng defaults với lumina-frontend
 * (retry 1, staleTime 60s, refetchOnWindowFocus false).
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
